import {
  LiveKitRoom,
  DisconnectButton,
  VideoTrack,
  ParticipantTile,
  GridLayout
} from "@livekit/components-react";

export const TypedLiveKitRoom = LiveKitRoom as React.ComponentType<any>;
export const TypedDisconnectButton =
  DisconnectButton as React.ComponentType<any>;
export const TypedVideoTrack = VideoTrack as React.ComponentType<any>;
export const TypedParticipantTile = ParticipantTile as React.ComponentType<any>;
export const TypedGridLayout = GridLayout as React.ComponentType<any>;
